import { Component, OnInit } from "@angular/core";
import { RestService } from "../services/rest.service";

@Component({
  selector: "app-pay",
  standalone: false,
  templateUrl: "./pay.component.html",
})
export class PayComponent implements OnInit {
  constructor(
    private rest: RestService
  ) {}
  user: any = {}
  requestDetails :any= {}
  idRequest = ''
  ngOnInit(): void {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const token = params.get("code") ? params.get("code") : localStorage.getItem('token');
    localStorage.setItem('token',token??'')
    this.rest.setToken(token??'')
    this.idRequest = window.location.pathname.split('/')[2]
    this.getDetails()
  }

  getDetails(){
    this.rest.get(`/client-request/${this.idRequest}/external-review`).subscribe({
      next:(value:any)=>{
        value.reserveDate = new Date(value.reserveDate).toLocaleDateString()
        this.requestDetails = value
      },
      error:()=>{}
    })
  }

  pay(){
    this.rest.post(`/client-request/pay`,{idClientPayment:this.requestDetails.invoice_id}).subscribe({
      next:(value:any)=>{
        window.location.replace(value.paymentURL)
      },
      error:()=>{}
    })
  }
}
